import { gql } from '@apollo/client'

export const TRADE_IN_GOOGLE_TOKENS = gql`
  mutation TRADE_IN_GOOGLE_TOKENS(
    $accessToken: String!
    $idToken: String!
    $invitationToken: String
  ) {
    tradeInGoogleTokens(
      accessToken: $accessToken
      idToken: $idToken
      invitationToken: $invitationToken
    ) {
      token
      expiresAt
    }
  }
`
